import React, { createElement } from "react";
import moduleCss from "./index.module.scss";

interface textInfoProps {
    title?: string
}

const TextInfo_skin2 = (props: textInfoProps) => {
    const { title } = props

    return (
        <div className={moduleCss.text}>
            {title}
        </div>
    )
}

export default TextInfo_skin2
